/** `YYYY-MM` helpers for budget / dashboard period. */

const YM = /^\d{4}-\d{2}$/;

export function currentYearMonth(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function isValidYearMonth(value: string): boolean {
  if (!YM.test(value)) return false;
  const parts = value.split("-");
  const y = Number(parts[0]);
  const m = Number(parts[1]);
  if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
  return m >= 1 && m <= 12 && y >= 2000 && y <= 2100;
}

export function yearMonthToExpenseRange(ym: string): { from: string; to: string } {
  const [ys = "0", ms = "0"] = ym.split("-");
  const y = Number(ys);
  const m = Number(ms);
  const last = new Date(y, m, 0);
  return {
    from: `${ys}-${ms}-01`,
    to: `${ys}-${ms}-${String(last.getDate()).padStart(2, "0")}`,
  };
}

export function shiftYearMonth(ym: string, deltaMonths: number): string {
  const [ys = "0", ms = "0"] = ym.split("-");
  const y = Number(ys);
  const m = Number(ms);
  const d = new Date(y, m - 1 + deltaMonths, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}
